import { Component } from '@opten/gin-tonic/helpers/compiler';
import { MapExtended } from '@opten/gin-tonic/components/map-extended/index';
declare const Cookiebot;
@Component({ className: 'js-map-extended' })
export class MapExtendedComponent {
	private mapExtended: MapExtended;
	constructor(private element: HTMLElement) {
		if (typeof Cookiebot !== 'undefined') {
			window.addEventListener('CookiebotOnAccept', () => {
				if(Cookiebot.consent.marketing && (this.mapExtended == undefined || this.mapExtended == null)){
					this.initMap(this.element);
				}
			});
		} else {
			this.initMap(this.element);
		}
	}

	private getMapStyles() {
		return [
			{
				stylers: [
					{
						hue: '#f7a3a7'
					},
					{
						saturation: -2
					}
				]
			},
			{
				featureType: 'poi.park',
				stylers: [
					{
						visibility: 'off'
					}
				]
			},
			{
				featureType: 'road',
				elementType: 'geometry',
				stylers: [
					{
						lightness: 100
					},
					{
						visibility: 'simplified'
					}
				]
			},
			{
				featureType: 'water',
				elementType: 'geometry.fill',
				stylers: [
					{
						color: '#effefd'
					},
					{
						saturation: 50
					}
				]
			}
		];
	}

	private initMap(element: HTMLElement) {
		const mapStylesAll = this.getMapStyles();
		this.mapExtended = new MapExtended(element, {
			mapCenter: {lat: parseFloat(element.getAttribute('data-map-center-lat')), lng: parseFloat(element.getAttribute('data-map-center-lng'))},
			mapStyles: mapStylesAll,
			styledMapName: 'ifa',
			zoom: parseFloat(element.getAttribute('data-zoom')),
			mapApiKey: element.getAttribute('data-map-key'),
			nonce: element.getAttribute('data-nonce')
		});
	}
}
// import { Loader, LoaderOptions } from 'google-maps';

// @Component({className: 'js-google-maps'})
// export class GoogleMapsComponent {
// 	constructor(private element: HTMLElement) {

// 		const options: LoaderOptions = {language: element.getAttribute('data-map-language')};
// 		const loader = new Loader(element.getAttribute('data-map-key'), options);

// 		loader.load().then(google => {
// 			const map = new google.maps.Map(element, {
// 				center: {lat: parseFloat(element.getAttribute('data-latitude')), lng: parseFloat(element.getAttribute('data-longitude'))},
// 				zoom: parseFloat(element.getAttribute('data-zoom')),
// 				styles: [
// 					{
// 							"stylers": [
// 									{
// 											"hue": "#f7a3a7"
// 									},
// 									{
// 											"saturation": -2
// 									}
// 							]
// 					},
// 					{
// 							"featureType": "poi.park",
// 							"stylers": [
// 									{
// 											"visibility": "off"
// 									}
// 							]
// 					},
// 					{
// 							"featureType": "road",
// 							"elementType": "geometry",
// 							"stylers": [
// 									{
// 											"lightness": 100
// 									},
// 									{
// 											"visibility": "simplified"
// 									}
// 							]
// 					},
// 					{
// 							"featureType": "water",
// 							"elementType": "geometry.fill",
// 							"stylers": [
// 									{
// 											"color": "#effefd"
// 									},
// 									{
// 											"saturation": 50
// 									}
// 							]
// 					}
// 			]
// 			});
// 		});
// 	}
// }
